import { render, staticRenderFns } from "./InfoDetailsMina.vue?vue&type=template&id=4e0b1a68&scoped=true"
var script = {}
import style0 from "./InfoDetailsMina.vue?vue&type=style&index=0&id=4e0b1a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0b1a68",
  null
  
)

export default component.exports